import React from 'react';

import styles from '../WorkJourneyRealTime.module.less';

export const menuItemIcon = (iconName: string): React.ReactNode => (
  <i className={`material-symbols-outlined ${styles.menuIcon}`}>{iconName}</i>
);
